import React from "react";
import { useVendorController } from "../../utilities/vendor/hooks";
import {
  CurrentVendorContext,
  VendorControllerContext,
} from "../../utilities/vendor/context";
import { Spacings, View } from "react-native-ui-lib";
import {
  Text,
  Button,
  Page,
  VStack,
  Stack,
  TextButton,
} from "@towersystems/roam-common-native";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { AnimatedDots } from "../AnimatedDots";

export interface VendorControllerProps {
  children?: React.ReactNode;
}

export const VendorController = ({ children }: VendorControllerProps) => {
  const [error, setError] = React.useState(false);
  const vendorContext = useVendorController();
  const { currentVendor, queryCurrentVendor } = vendorContext;
  const { isLoggedIn, logout } = useAuthenticationProvider();

  const handleQueryCurrentVendor = React.useCallback(async () => {
    setError(false);
    queryCurrentVendor().catch((e) => {
      setError(true);
    });
  }, []);

  React.useEffect(() => {
    handleQueryCurrentVendor();
  }, []);

  const isLoggedInMarkup = isLoggedIn && (
    <View
      style={{
        position: "absolute",
        bottom: Spacings.s4,
        left: Spacings.s4,
        right: Spacings.s4,
        alignItems: "center",
      }}
    >
      <TextButton
        onPress={() => {
          logout();
        }}
        color="subdued"
      >
        Cancel and logout
      </TextButton>
    </View>
  );

  if (error) {
    return (
      <Page fullWidth scrollable={false}>
        <VStack
          spacing={Spacings.s2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <View
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text variant="heading">Whoops!...</Text>
            <Text variant="heading3">Something went wrong</Text>
            <Text variant="caption" style={{ marginTop: Spacings.s2 }}>
              Refresh page to try again, or reset local data.
            </Text>
          </View>
          <View
            style={{
              marginTop: Spacings.s4,
            }}
          >
            <Stack>
              <Button
                label="Try Again"
                isAction
                onPress={handleQueryCurrentVendor}
              ></Button>
            </Stack>
          </View>
        </VStack>
        {isLoggedInMarkup}
      </Page>
    );
  }

  if (!currentVendor) {
    return (
      <VendorControllerContext.Provider value={vendorContext}>
        <Page scrollable={false}>
          <VStack
            spacing={Spacings.s2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <AnimatedDots text="Loading Vendor Details" />
          </VStack>
          {isLoggedInMarkup}
        </Page>
      </VendorControllerContext.Provider>
    );
  }

  return (
    <VendorControllerContext.Provider value={vendorContext}>
      <CurrentVendorContext.Provider
        value={{
          currentVendor,
        }}
      >
        {children}
      </CurrentVendorContext.Provider>
    </VendorControllerContext.Provider>
  );
};
